import React from 'react'
import './my-momentum-list.styles.scss';
import PlayerRecordsList from '@/components/SHARED/player-records-list/player-records-list.component';

const MyMomentumList = ({
  gameData,
  playerData,
  gameElements
}) => {

  return (
    <div className='momentum-cards-list'>
      <PlayerRecordsList
        gameData={gameData}
        playerData={playerData}
        gameElements={gameElements}
        activityType='momentum'
        title='Momentum Cards'
        summaryLabel='Momentum Cards Drawn'
        summaryIcon='/images/icons/momentum2.png'
        emptyText='No momentum cards yet...' />
    </div>
  )
}

export default MyMomentumList
